import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { toCbBranch } from '../../../branches/data/datasources/branch-shape';

/** `GET /client/:cid/hubs/:hub_id`: the hub with its branches and regions, branch locations from `GET /branch`. */
export const getHub = async (hub_id: string): Promise<any> => {
  const [hub, listed] = await Promise.all([
    lpRequest('GET', clientPath(`/hubs/${hub_id}`)),
    lpRequest('GET', clientPath('/branch'))
  ]);
  // The hub read maps a `{_latitude, _longitude}` stored location to `{}`; the branch list keeps it.
  const locations = new Map((listed || []).map((branch: any) => [branch.id, branch.location]));

  return {
    ...hub,
    branches: (hub.branches || []).map((branch: any) =>
      toCbBranch({ ...branch, location: locations.get(branch.id) ?? branch.location }, hub.id)
    ),
    regions: hub.regions || []
  };
};
